export default {"src":"/_next/static/media/kosher.e03436a2.svg","height":16,"width":16};